///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Component } from '@angular/core';
import { GtthAccessDeniedModalService } from './accessdenied.service';

@Component({
    selector: 'winde-access-denied-modal',
    templateUrl: './accessdenied.component.html',
    styleUrls: ['./accessdenied.scss'],
    standalone: false
})
export class GtthAccessDeniedModalComponent {
    constructor(public accessDeniedService: GtthAccessDeniedModalService) {}

    close() {
        this.accessDeniedService.close();
    }
}
